import { useEffect } from 'react';

import {
  boardCollectionHasClipsSelector,
  boardCollectionHasSubmittedFormSelector,
} from '~/store/boardCollection/selectors';
import { isCypressRun } from '~/utils/PathUtils';
import { useAirStore } from '~/utils/ReduxUtils';

export const useAlertOnUnsubmittedCCForm = () => {
  const store = useAirStore();

  useEffect(() => {
    const handleBeforeunload = (event: BeforeUnloadEvent) => {
      const hasClips = boardCollectionHasClipsSelector(store.getState());
      const hasSubmitted = boardCollectionHasSubmittedFormSelector(store.getState());

      // ignore reload warning on cypress run
      if (isCypressRun()) {
        return;
      }

      if (hasClips && !hasSubmitted) {
        event.preventDefault();
        // beforeunload requires returning a string if we want to intercept this event.
        // IMPORTANT: this string won't be presented to the user - browser have their own messages, which can't be changed.
        return (event.returnValue =
          'Leave page?\nYour items have not been submitted. Changes you made may not be saved');
      }
    };

    window.addEventListener('beforeunload', handleBeforeunload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeunload);
    };
  }, [store]);
};
